import React from 'react';
import {
  Table,
  TableRow,
  TableBody,
  Box,
  TableCell,
  CircularProgress,
} from '@mui/material';
import {
  StyledTableCellFlyover,
  tableWithNoDataStyles,
} from '../../../../components/Common/Common.styled';
import { SubmissionStatus } from '../../../../generated/graphql';
import NoResults from '../../../../components/NoResults';
import WavingLadyFrame from '../../../../components/Icons/WavingLadyFrame';
import useAdminStudentSlideout from './admin-student-slideout-hook';
import TruncateStudentName from './TruncateStudentName';

interface Props {
  benchmarkId: string,
  setStudentCount: Function,
}

const NotStarted = ({ benchmarkId, setStudentCount }: Props) => {
  const { totalCount, slideoutStudents, loading } = useAdminStudentSlideout({
    benchmarkId: benchmarkId,
    statusList: [SubmissionStatus.NotStarted],
  });
  setStudentCount(totalCount);

  const isTableEmpty = !loading && slideoutStudents?.length === 0;

  return (
    <Box>
      <Table
        stickyHeader
        aria-label="students submissions table"
        sx={{ ...((loading || isTableEmpty) && tableWithNoDataStyles.noData) }}
      >
        <TableBody>
          {slideoutStudents && slideoutStudents?.map((student) => (

            <TableRow key={student.student_number}>
              <StyledTableCellFlyover>
                <TruncateStudentName student={student} maxChars={40} />
              </StyledTableCellFlyover>
            </TableRow>

          ))}
          {isTableEmpty && (
            <TableRow>
              <TableCell
                colSpan={6}
                align="center"
              >
                <NoResults
                  label="No Students"
                  description="No students at this step yet"
                  svgComponent={<WavingLadyFrame />}
                />
              </TableCell>
            </TableRow>
          )}
          {loading && (
            <TableRow>
              <TableCell
                colSpan={6}
                align="center"
              >
                <CircularProgress size={28} />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Box>
  );
};

export default NotStarted;
